import { combineReducers } from '@reduxjs/toolkit'
import rememberPageSlice from './slices/rememberPageSlice'
import bookmarksSlice from './slices/bookmarksSlice'
import appSlice from './slices/appSlice'
import pdfStoreSlice from './slices/pdfStore'
import searchTextPdf from './slices/searchTextPdfSlice'
import drawSlice from './slices/drawSlice'

export const rootReducer = combineReducers({
  pagesRemember: rememberPageSlice,
  bookmarks: bookmarksSlice,
  app: appSlice,
  pdfStore: pdfStoreSlice,
  searchTextPdf: searchTextPdf,
  draw: drawSlice
})
export type RootState = ReturnType<typeof rootReducer>
